import React from "react";
import { Menu, MenuItem, Sidebar } from "react-pro-sidebar";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { Props } from "./AdminSidebar.config";
import styles from "./SidebarAdmin.module.scss";

export const SidebarAdmin: React.FC<Props> = ({
  collapsed,
  toggled,
  setCollapsed,
  setToggled,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const isActiveLink = (path: string) => {
    return location.pathname === path ? styles.activeLink : "";
  };

  return (
    <Sidebar
      collapsed={collapsed}
      toggled={toggled}
      onBackdropClick={() => setToggled(false)}
      breakPoint="md"
      backgroundColor="#fff"
      rootStyles={{
        boxShadow: "0 2px 15px rgba(0, 0, 0, .1)",
        height: "100vh",
      }}
    >
      <div className={styles.logo}>
        <img
          src="/assets/logo.png"
          alt="Logo"
          style={{ padding: collapsed ? "0 0" : "4px" }}
          onClick={() => {
            navigate("/admin");
          }}
        />
      </div>

      <Menu>
        {!collapsed && (
          <div className={styles.menuTitle}>
            <p>İçerik Yönetimi</p>
          </div>
        )}

        <MenuItem
          component={
            <NavLink
              to="/admin/anasayfa"
              className={isActiveLink("/admin/anasayfa")}
            />
          }
          icon={<i className="pi pi-home" />}
        >
          Anasayfa Yönetimi
        </MenuItem>

        <MenuItem
          component={
            <NavLink
              to="/admin/hakkimizda"
              className={isActiveLink("/admin/hakkimizda")}
            />
          }
          icon={<i className="pi pi-info-circle" />}
        >
          Hakkımızda Yönetimi
        </MenuItem>
        <MenuItem
          component={
            <NavLink
              to="/admin/popupyonetimi"
              className={isActiveLink("/admin/popupyonetimi")}
            />
          }
          icon={<i className="pi pi-info-circle" />}
        >
          PopUp Yönetimi
        </MenuItem>

        <MenuItem
          component={
            <NavLink
              to="/admin/temalar"
              className={isActiveLink("/admin/temalar")}
            />
          }
          icon={<i className="pi pi-palette" />}
        >
          Tema Yönetimi
        </MenuItem>

        <MenuItem
          component={
            <NavLink
              to="/admin/projeler"
              className={isActiveLink("/admin/projeler")}
            />
          }
          icon={<i className="pi pi-briefcase" />}
        >
          Proje Yönetimi
        </MenuItem>

        {/* <MenuItem
          component={
            <NavLink
              to="/admin/yarismayonetimi"
              className={isActiveLink("/admin/yarismayonetimi")}
            />
          }
          icon={<i className="pi pi-users" />}
        >
          Yarışma Yönetimi
        </MenuItem> */}

        <MenuItem
          component={
            <NavLink
              to="/admin/birlikteGuzellestirelim"
              className={isActiveLink("/admin/birlikteGuzellestirelim")}
            />
          }
          icon={<i className="pi pi-users" />}
        >
          Workshop Yönetimi
        </MenuItem>

        <MenuItem
          component={
            <NavLink
              to="/admin/iletisim"
              className={isActiveLink("/admin/iletisim")}
            />
          }
          icon={<i className="pi pi-envelope" />}
        >
          İletişim Yönetimi
        </MenuItem>
      </Menu>
    </Sidebar>
  );
};
